import { fetchAuthSession } from "aws-amplify/auth";
import { AuthSession } from '@aws-amplify/core';
import * as storage from './roborpoc_storage';
import _ from 'lodash';

export const getUserIdentity = async () => {
    let session  = await fetchAuthSession()
    return {
        sso_isid: session.tokens.idToken.payload['cognito:username'],
        isid: removePingfedPrefix(session.tokens.idToken.payload['cognito:username']),
        email: session.tokens.idToken.payload['email'],
        cognito_groups: session.tokens.idToken.payload['cognito:groups']
    }
}

export function removePingfedPrefix(inputString) {
    return inputString.replace(/^MERCK-PINGFED-SSO_/, '');
}

export async function saveUserInfo(session) {
  let _identity = _.pick(session?.tokens?.idToken?.payload, ['email', 'family_name', 'given_name', 'identities', 'cognito:groups'])
  let userId = null

  // const existingGroups = _identity['cognito:groups'] || [];
  // const mockGroups = ['Admin', 'Sizing'];
  // _identity['cognito:groups'] = Array.from(new Set([...existingGroups, ...mockGroups]));
  //@ts-ignore
  let object_with_userId = _.find(_identity?.['identities'], 'userId')
  if (object_with_userId) {
    userId = object_with_userId['userId']
  }
  storage.set('user.email', _identity.email);
  storage.set('user.isid', userId);
  storage.set('user.familyName', _identity.family_name);
  storage.set('user.givenName', _identity.given_name);
  storage.set('user.cognito:groups', JSON.stringify(_identity['cognito:groups']))
}
